"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.useWeeklyScheduleControlModels = void 0;
const react_1 = require("react");
require("../types");
const models_1 = require("../../../models");
const WeeklyScheduleModelsConverter_1 = require("../../../WeeklyScheduleModelsConverter");
const useWeeklyScheduleControlModels = ({ weeklyScheduleModel, }) => {
    const initialValue = WeeklyScheduleModelsConverter_1.WeeklyScheduleModelsConverter.toControlModel(weeklyScheduleModel.getValue());
    const [weeklyScheduleControlModel] = react_1.useState(() => new models_1.WeeklyScheduleControlModel(initialValue));
    return {
        weeklyScheduleControlModel: weeklyScheduleControlModel,
    };
};
exports.useWeeklyScheduleControlModels = useWeeklyScheduleControlModels;
//# sourceMappingURL=useWeeklyScheduleControlModels.js.map